/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { ROUTES } from "../../../../shared";
import FilterButton from "../../components/FilterButton";
import FilterMenu from "../../components/FilterMenu";
import FilterDropdown from "../../FilterDropdown/FilterDropdown";
import { useFilters } from "../../hooks";
import { useStyles } from "../../styles";
import { FILTER_NAMES, TRANSLATE_STRINGS } from "../../types";

interface SharedIntegrationsFiltersProps {
  route: ROUTES;
}

const SharedIntegrationsFilters = ({
  route
}: SharedIntegrationsFiltersProps) => {
  const { anchorEl, handleOpenMenu, handleCloseMenu, isPartOfFilterMenu } =
    useFilters(route);

  const { t } = useTranslation();

  const { filtersMainBlock, filtersListBlock, separateFilterDropdown } =
    useStyles();

  return (
    <div css={css(filtersMainBlock)} data-testid="shared-integrations-filters">
      {!isPartOfFilterMenu() && (
        <FilterDropdown
          route={route}
          filterName={FILTER_NAMES.Status}
          placeholder={t("Filter##status")}
          translateString={TRANSLATE_STRINGS.General}
          css={css(separateFilterDropdown)}
        />
      )}

      <FilterButton
        route={route}
        onOpen={handleOpenMenu}
        hasMoreFilters
        hasLoadingCustomStyle
      />
      <FilterMenu
        isOpen={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        hasMoreFilters
        anchorEl={anchorEl}
      >
        <div css={css(filtersListBlock)}>
          {isPartOfFilterMenu() && (
            <FilterDropdown
              route={route}
              filterName={FILTER_NAMES.Status}
              placeholder={t("Filter##status")}
              translateString={TRANSLATE_STRINGS.General}
            />
          )}

          <FilterDropdown
            route={route}
            filterName={FILTER_NAMES.Company}
            placeholder={t("Filter##company")}
          />
        </div>
      </FilterMenu>
    </div>
  );
};

export default SharedIntegrationsFilters;
